"use client";

import React, { useEffect, useState } from "react";
import { Spinner } from "@tracify/ui/spinner";
import { StatusIndicator } from "./StatusIndicator";
import { ThemeLogo } from "./ThemeLogo";

const LOADING_MESSAGES = [
  "Summoning insights from the void…",
  "Consulting the data spirits…",
  "Warming up the dashboards…",
  "Counting to infinity…",
  "Hold tight—your insights are crystallizing…",
  "Brewing a fresh batch of analytics…",
  "Waking up the cache…",
  "Consulting the star charts…",
  "Generating… more generators…",
  "One moment while we math…",
  "Convincing the charts to cooperate…",
  "Dusting off the KPIs…",
  "Mining for signal…",
  "Looking for patterns in the chaos…",
  "Chasing down the latest numbers…",
  "Double-checking the math gremlins…",
  "Teaching the graphs some manners…",
  "Fetching facts, not feelings…",
];

const LOADING_MESSAGE_ROTATION_MS = 12000;

function getRandomLoadingMessageIndex() {
  return Math.floor(Math.random() * LOADING_MESSAGES.length);
}

export function AppLoadingScreen() {
  const [loadingMessageIndex, setLoadingMessageIndex] = useState<number | null>(
    null
  );

  useEffect(() => {
    const initialIndex = getRandomLoadingMessageIndex();
    setLoadingMessageIndex(initialIndex);

    const intervalId = window.setInterval(() => {
      setLoadingMessageIndex(
        (currentIndex) =>
          ((currentIndex ?? initialIndex) + 1) % LOADING_MESSAGES.length
      );
    }, LOADING_MESSAGE_ROTATION_MS);

    return () => window.clearInterval(intervalId);
  }, []);

  return (
    <div className="relative flex min-h-svh w-full flex-col items-center justify-center text-foreground">
      <div className="absolute bottom-8 flex flex-col items-center w-full gap-8">
        <div className="h-6">
          <StatusIndicator />
        </div>
        <ThemeLogo width={166.4} height={28} priority alt="logo" />
      </div>
      <Spinner size="large" className="mt-8" />
      <p className="mt-2 min-h-6 max-w-md px-6 text-center font-semibold">
        {loadingMessageIndex === null
          ? null
          : LOADING_MESSAGES[loadingMessageIndex]}
      </p>
    </div>
  );
}
